module.exports = __webpack_public_path__ + "static/media/upvLogo.6ab6af8b.jpeg";